import React, { Component } from 'react';
import './Layout.css';
import { Navbar, Nav, Modal } from 'reactstrap'
import { NavLink, withRouter } from "react-router-dom";
import Copyright from "../Copyright/Copyright";
import { connect } from 'react-redux';
import { fetch_firm_settings } from "../../settings/firm/redux/actions";
import LicensedScaDisclosure from '../DamageReports/Disclosure';
import RiskToolDisclosure from '../../ace/Disclosure';
import SubscriptionExpirationAlert from '../../common/components/SubscriptionExpirationAlert';


class Layout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			searchValue: "",
			searchArray: [],
			currentCases: [],
			sortValue: '',
			sortOrder: '',
			isAdminToken: localStorage.getItem('isAdminToken'),
			showPopup: false,
			popupType: "",
			showSubscriptionAlert: false,
		};

		this.logout = this.logout.bind(this);
		this.goToPage = this.goToPage.bind(this);
		this.togglePopup = this.togglePopup.bind(this)
		this.toggleSubscriptionAlert = this.toggleSubscriptionAlert.bind(this);
	}

	componentWillMount() {

	}
	
	componentDidMount() {

	}

	goToPage(url) {
		this.props.history.push(url); 
		if(url==='/mycases'){
			sessionStorage.setItem('Type','CASE')
			sessionStorage.setItem('DANDO',false);
		}
		localStorage.removeItem("sortParams");
		localStorage.removeItem("searchValue");
		sessionStorage.removeItem('tempSearchValue')
		// window.location.reload(false)
		if(this.props.firmSettings.subscriptionStatus !== "active") {
			this.setState({ ...this.state, showSubscriptionAlert: true });
		}
	}
	logout = (props) => {
		localStorage.removeItem('searchValue');
		localStorage.removeItem('sortParams');
		sessionStorage.removeItem('tempSearchValue')
		this.props.keycloak.logout({ redirectUri:  window.location.origin});
	}

	togglePopup(type) {
		this.setState({ ...this.state, popupType: type, showPopup: !this.state.showPopup });
	}

	toggleSubscriptionAlert() {
		this.setState({
			...this.state,
			showSubscriptionAlert: false,
		});
	}

	render() {
		    const { risk, severity, alert } = this.props.firmSettings;
		return (
			<React.Fragment>
				<Navbar className={"NavBar"}>
					<NavLink to="/" exact><img src="/SAR-Logo-White.png" className={"SARLogo"} alt="SAR" /></NavLink>
					<Nav className="ml-auto" navbar>
						{/* <NavLink className={"NavNavigation"} onClick={() => this.goToPage('/commissions')} to="/commissions" exact>Commissions</NavLink>
						<NavLink className={"NavNavigation"} onClick={() => this.goToPage('/')} to="/" exact>Cases</NavLink> */}
						<div id={"logout-link"} className={"NavNavigation displayInline"} onClick={() => this.goToPage('/publications')}>Publications</div>
						<div id={"logout-link"} className={"NavNavigation displayInline"} onClick={() => this.goToPage('/')}>SCA Database</div>
						<div id={"logout-link"} className={"NavNavigation displayInline"}
							onClick={() => {
								if(severity) { 
									this.goToPage('/mycases'); 
								} else { 
									this.togglePopup("severity");
								}
							}}>Licensed SCAs</div>
						{/*<div id={"logout-link"} className={"NavNavigation displayInline"} onClick={() => this.goToPage('/commissions')}>Commission</div>*/}
						<div id={"logout-link"} className={"NavNavigation displayInline"}  
							onClick={() => {
								if(risk) { 
								this.goToPage('/dandos'); 
								} else { 
									this.togglePopup("risk");
								}
							}}>Risk Tool</div>
						<div id={"logout-link"} className={"NavNavigation displayInline"} onClick={() => this.goToPage('/ACEalerts')}>ACE Alerts</div>
						<div id={"logout-link"} className={"NavNavigation"} onClick={() => this.logout()}>Logout</div>
					</Nav>
				</Navbar>
				<div className={"NavDivider"} />
				<main className={'Content'}>{this.props.children}</main>
				<div className={"Footer"}>
					<Copyright />
				</div>
				<Modal
          			isOpen={this.state.showPopup}
          			toggle={this.togglePopup}
					className="warning-model"
        		>
          			{this.state.popupType === "severity" ? <LicensedScaDisclosure /> : <RiskToolDisclosure />}
					<button className='sar-btn close-btn' onClick={this.togglePopup}>Close</button>
        		</Modal>
				<SubscriptionExpirationAlert showSubscriptionAlert={this.state.showSubscriptionAlert} updateSubscriptionStatus={this.toggleSubscriptionAlert} />
			</React.Fragment>
		);
	}

}

const mapStateToProps = (state) => {
	return {
		firmSettings: state.firmSettings
	}
};

const mapDispatchToProps = dispatch => {
	return {
		fetch_firm_settings: () => dispatch(fetch_firm_settings())
	}
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Layout));


// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js